
import React from "react";
import "./teamInfo.scss";
import { FaHandshake } from "react-icons/fa"; // handshake icon

const Sponsorship = () => (
  <div className="team__info flex-center">
       <div style={{ textAlign: "center" }}>
      <FaHandshake size={40} style={{ marginBottom: "10px", color: "#333" }} />
      <h4 className="font20 weight800">Sponsorship</h4>
      <p className="font12 weight500">
        Uncover the potential of sponsorship deals. We connect football brands with the right sponsors, ensuring mutually beneficial partnerships that fuel growth and success.
      </p>
    </div>
  </div>
);

export default Sponsorship;

